<template>
    <div class="breadcrumb">
      <template v-for="(item, index) in visibleCrumbs">
        <span :key="index"
          v-if="item.type === 'ellipsis'" 
          class="ellipsis"
          @click="expand"
          title="展开更多"
        >
          ...
        </span>
        <template v-else>
          <span 
            :class="['breadcrumb-item', { 'is-link': item.clickable, 'is-current': index === visibleCrumbs.length - 1 }]"
            @click="item.clickable && onItemClick(item, index)" :title="item.name"
          >
            {{ item.name }}
          </span>
          <span v-if="index < visibleCrumbs.length - 1" class="separator">></span>
        </template>
      </template>
    </div>
  </template>
  
  <script>
  export default {
    name: "Breadcrumb",
    props: {
      // 面包屑数据数组，每个元素包含 name 和其他自定义属性
      crumbs: {
        type: Array,
        required: true,
        default: () => []
      },
      // 是否启用自动折叠功能
      autoCollapse: {
        type: Boolean,
        default: true
      },
      // 最大显示项目数（包括首项和末尾项）
      maxItems: {
        type: Number,
        default: 3
      }
    },
    emits: ['item-click'],
    computed: {
      visibleCrumbs() {
        // 如果不需要自动折叠或者项目数未超过限制，则显示所有项目
        if (!this.autoCollapse || this.crumbs.length <= this.maxItems) {
          return this.crumbs.map((crumb, index) => ({
            ...crumb,
            clickable: index < this.crumbs.length - 1 // 最后一项不可点击
          }));
        }
  
        // 构造折叠后的面包屑数组
        const result = [];
        
        // 添加第一项
        result.push({
          ...this.crumbs[0],
          clickable: true
        });
        
        // 添加省略号
        result.push({
          type: 'ellipsis'
        });
        
        // 添加最后两项（如果存在）
        if (this.crumbs.length >= 2) {
          result.push({
            ...this.crumbs[this.crumbs.length - 2],
            clickable: true
          });
        }
        
        if (this.crumbs.length >= 3) {
          result.push({
            ...this.crumbs[this.crumbs.length - 1],
            clickable: false // 当前项不可点击
          });
        }
        
        return result;
      }
    },
    methods: {
      onItemClick(item, index) {
        this.$emit('item-click', item, index);
      },
      expand() {
        // 可以在这里添加展开逻辑，例如通知父组件
        this.$emit('expand');
      }
    }
  };
  </script>
  
  <style scoped lang="scss">
  .breadcrumb {
    display: flex;
    align-items: center;
    font-size: 16px;
    padding: 10px 0;
  
    .breadcrumb-item {
      color: #999999;
      padding: 0 8px;
  
      &.is-link {
        cursor: pointer;
  
        &:hover {
          color: #ff5967;
        }
      }
  
      &.is-current {
        color: #333333;
        font-weight: bold;
      }
  
      &:first-child {
        padding-left: 0;
      }
    }
  
    .ellipsis {
      padding: 0 8px;
      cursor: pointer;
      color: #999999;
  
      &:hover {
        color: #ff5967;
      }
    }
  
    .separator {
      color: #999999;
      padding: 0 2px;
    }
  }
  </style>